import { FC } from 'react';
import styles from './Benefits.module.scss';
import { benefits } from '../../../components/_dummyData/findSupplier';

export const Benefits: FC = () => {
    return (
        <div className={styles.container}>
            {benefits.map((el, id) => {
                return (
                    <div className={styles.card} key={id}>
                        <img
                            src={`/assets/customers/${el.icon}.svg`}
                            alt="Offer"
                        />
                        <div className={styles.title}>{el.title}</div>
                        <div>
                            {el.rows.map((e, i) => {
                                return (
                                    <div key={i} className={styles.text}>
                                        {e}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
